module.exports = __webpack_public_path__ + "assets/media/gamburger.42eea85e.svg";